import { WrappedIcon } from './WrappedIcon';

export * from './WrappedIcon';

export default WrappedIcon;
